var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"main-bluebutton",class:{
    'width-100': _vm.type == 'full',
    'mobile-btn': _vm.type == 'mobile',
    'login-btn': _vm.type == 'login',
    'header-height': _vm.type == 'header',
    'width-50': _vm.type == 'half',
  },style:(_vm.isLaptop ? `width: ${_vm.lapwidth}px` : `width:${_vm.mobwidth}px `),on:{"click":function($event){$event.stopPropagation();return _vm.$emit('clicked')}}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }